import { defineMessages } from "react-intl";

const messages = defineMessages({
    unableToDeactivate:{
	id:"app.admin-fail-deactivate-branch-modal.unableToDeactivate",
	description:"branch",
	defaultMessage:"Unable to deactivate, Kindly move the following users to a different branch first to be able to deactivate this branch"
    },
	attachesDocsMandatory:{
	id: "app.admin-console-create-public-admin.attachesDocsMandatory",
	description: "upload docs*",
	defaultMessage: "Upload Documents*"
	},
	activate:{
	id: "app.admin-public-admin-profile.activate",
	description: "back",
	defaultMessage: "ACTIVATE"
    },
    deactivate:{
	id: "app.admin-public-admin-profile.deactivate",
	description: "back",
	defaultMessage: "DEACTIVATE"
    },
});

export default messages;